import React from "react";

interface SelectOption {
  label: string;
  value: string;
}

interface PremiumSelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  label: string;
  options: SelectOption[];
}

const PremiumSelect: React.FC<PremiumSelectProps> = ({
  label,
  options,
  ...props
}) => (
  <div className="mb-4 text-left">
    <label className="block text-[10px] font-bold text-slate-500 mb-1.5 tracking-wider uppercase pl-1">
      {label}
    </label>
    <select
      className="w-full bg-slate-50 border border-slate-200 text-slate-800 rounded-xl px-4 py-3 text-base font-medium focus:outline-none focus:border-rose-400 focus:bg-white focus:ring-4 focus:ring-rose-50 transition-all appearance-none"
      {...props}
    >
      {options.map((opt) => (
        <option key={opt.value} value={opt.value}>
          {opt.label}
        </option>
      ))}
    </select>
  </div>
);

export default PremiumSelect;
